import React from 'react';
import { Typography, Card, Spin } from 'antd';
import { usePageManager } from '../../../../contexts/PageManager/Provider';
import IconCitizen from '~/assets/images/icons/icone256-cidadao.png';

const { Title, Text } = Typography;

export default function Users() {
  const { totalUsers, totalUsersLoading } = usePageManager();

  const Field = ({ label, value }) => {
    return (
      <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
        <Text>{label}:</Text>
        {value ? (
          <Text style={{ color: '#143c6d', fontWeight: 'bold' }}>{value}</Text>
        ) : (
          <Spin size="small" />
        )}
      </div>
    );
  };

  return (
    <Card bodyStyle={{ padding: 0 }}>
      <div
        style={{
          padding: '6px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#143c6d',
          borderTopRightRadius: '4px',
          borderTopLeftRadius: '4px',
        }}
      >
        <Title level={5} style={{ margin: 0, padding: 0, color: 'white' }}>
          Usuários
        </Title>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          padding: '0px 8px',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <div>
          <img src={IconCitizen} style={{ width: 64 }} alt="..." />
        </div>
        <div>
          <Field
            label="Total"
            value={totalUsersLoading ? null : totalUsers.total}
          />
          <Field
            label="Administradores"
            value={totalUsersLoading ? null : totalUsers.admins}
          />
          <Field
            label="Agentes"
            value={totalUsersLoading ? null : totalUsers.agents}
          />
        </div>
      </div>
    </Card>
  );
}
